import { PaginatedResponse } from '@common/dto/magazzino.dto';
import { IWarehouseError, WarehouseMaterialCode, WarehouseUserSkill } from '@common/dto/magazzino.types';

/**
 * Frontend-only warehouse types: request DTOs and UI-side helpers.
 * Response shapes live in the shared contract `@common/dto/magazzino.types`; which operation
 * answers which shape is `MagazzinoResponseList` in `@common/dto/magazzino.dto`.
 */

export const API_PLACEHOLDER = 'api/magazzino/dispatch';

/* Table viewport heights (nzScroll.y) — the scaffold rule in sass-7-1/components/warehouse.scss:
 * tables own the viewport left over by the screen header/footer and scroll internally. */
/** Full-height list tables (screen header + breadcrumb above, paginator below). */
export const WH_TABLE_Y = 'calc(100vh - 22rem)';
/** Tables under a taller header block (tabs, extra toolbars). */
export const WH_TABLE_Y_SHORT = 'calc(100vh - 26rem)';
/** Nested detail tables inside expandable rows: fixed, the parent row scrolls the page. */
export const WH_TABLE_Y_NESTED = '300px';

export type DispatchQueryObj = {
  [key: string]: string;
};



/* Carico/Scarico manuale/template */

/**
 * Projection of a grouped warehouse element row (`warehouses.elements.listGroupByMaterialCodes`)
 * onto the fields the load wizard resolves; a full `WarehouseMaterialCode` satisfies it, so
 * `resolveMaterialCode` can serve both the lookup and the source-warehouse read through it.
 */
export type WarehouseSourceMaterialCode =
  Pick<WarehouseMaterialCode, 'id' | 'ean' | 'codeName' | 'managementMode'>
  & { materialType: { value: string } };

export type MovementLoadFiles = {
  documentFile?: File;
  templateFile?: File;
};

export type TemplateErrorResponse = {
  code: string;
  message: string;
  errors: IWarehouseError[];
};

export type IWarehouseDestination = {
  id: string;
  company: string;
  name: string;
  type: { id: string; value: 'MOBILE' | 'FISSO' | 'COMODATO D\'USO' };
  sitePlate: string;
  capacity: number;
  responsibles: { userId: string; userName: string }[];
};

export type IWarehouseDestinationResponse = PaginatedResponse<IWarehouseDestination>;

export type WarehouseSessionUser = {
  id: string;
  name: string;
  username: string;
  company: string;
  isGlobal: boolean;
  globalSkills: WarehouseUserSkill[];
};

